import { AuthenticateError } from './LowLevelUnifiedAuth';
import { deleteSecret, registerConnection } from './MCPApi';
import { UnifiedAuthModal } from './UnifiedAuthModal';
import { jsx as _jsx } from "react/jsx-runtime";
const registerMCPConnection = args => {
  const {
    mcpServerId,
    secretId
  } = args;
  return registerConnection(mcpServerId, secretId).then(response => {
    const mcpConnection = response.mcpConnection;
    if (mcpConnection !== null && mcpConnection !== void 0 && mcpConnection.secretId) {
      return mcpConnection.secretId;
    } else {
      throw new AuthenticateError('MCP connection not found');
    }
  }).catch(error => {
    throw new AuthenticateError(error.message);
  });
};
export const MCPAuthModal = ({
  portalId,
  authenticatorId,
  mcpServerId,
  appName,
  introScreen,
  successScreen,
  oAuthScope,
  appId,
  mcp,
  customParams,
  closeModal,
  onCancel,
  onComplete
}) => {
  const onAuthComplete = secretId => {
    return registerMCPConnection({
      mcpServerId,
      secretId
    }).then(connectionSecretId => {
      onComplete === null || onComplete === void 0 || onComplete(connectionSecretId);
      if (!successScreen) {
        closeModal();
      }
    }).catch(error => {
      void deleteSecret(mcpServerId, secretId);
      throw new AuthenticateError((error === null || error === void 0 ? void 0 : error.message) || 'Failed to register MCP connection');
    });
  };
  return /*#__PURE__*/_jsx(UnifiedAuthModal, {
    portalId: portalId,
    authenticatorId: authenticatorId,
    appName: appName,
    oAuthScope: oAuthScope,
    appId: appId,
    mcp: mcp,
    customParams: customParams,
    onComplete: secretId => {
      void onAuthComplete(secretId);
    },
    onCancel: () => {
      closeModal();
      onCancel === null || onCancel === void 0 || onCancel();
    },
    introScreen: introScreen,
    successScreen: successScreen
  });
};